import { render, staticRenderFns } from "./RoleManagement.vue?vue&type=template&id=1671f93c&scoped=true"
import script from "./RoleManagement.vue?vue&type=script&lang=js"
export * from "./RoleManagement.vue?vue&type=script&lang=js"
import style0 from "./RoleManagement.vue?vue&type=style&index=0&id=1671f93c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1671f93c",
  null
  
)

export default component.exports